(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3169],{

/***/ 12557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dd": function() { return /* binding */ onItemCustomization; },
/* harmony export */   "Tg": function() { return /* binding */ onItemUpdateBySignature; },
/* harmony export */   "d4": function() { return /* binding */ onItemUpdate; }
/* harmony export */ });
/* harmony import */ var _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63228);
/* harmony import */ var _utils_listeners__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25268);


const onItemUpdate = async (item, direction)=>{
    try {
        await _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_0__/* ["default"].updateCartItem */ .ZP.updateCartItem(item, {
            direction
        });
    } catch (err) {
        if (err.message === _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Exceptions.ITEM_CUSTOMIZATION_REQUIRED */ .XM.ITEM_CUSTOMIZATION_REQUIRED) {
            _utils_listeners__WEBPACK_IMPORTED_MODULE_1__/* .PubSub.getInstance */ .pS.getInstance().emit(_utils_listeners__WEBPACK_IMPORTED_MODULE_1__/* .EVENTS.ITEM_CUSTOMIZATION_REQUIRED */ .FP.ITEM_CUSTOMIZATION_REQUIRED, item);
        } else if (err.message === _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Exceptions.ITEM_REPEAT_OR_NOT_REQUIRED */ .XM.ITEM_REPEAT_OR_NOT_REQUIRED) {
            _utils_listeners__WEBPACK_IMPORTED_MODULE_1__/* .PubSub.getInstance */ .pS.getInstance().emit(_utils_listeners__WEBPACK_IMPORTED_MODULE_1__/* .EVENTS.ITEM_REPEAT_OR_NOT_REQUIRED */ .FP.ITEM_REPEAT_OR_NOT_REQUIRED, item);
        } else if (err.message === _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Exceptions.STORE_SELECTION_REQUIRED */ .XM.STORE_SELECTION_REQUIRED) {
            _utils_listeners__WEBPACK_IMPORTED_MODULE_1__/* .PubSub.getInstance */ .pS.getInstance().emit(_utils_listeners__WEBPACK_IMPORTED_MODULE_1__/* .EVENTS.STORE_SELECTION_REQUIRED */ .FP.STORE_SELECTION_REQUIRED);
        }
        throw err;
    }
};
const onItemUpdateBySignature = async (item, direction)=>{
    await _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_0__/* ["default"].updateCartItemBySignature */ .ZP.updateCartItemBySignature(item, direction);
};
const onItemCustomization = async (item)=>{
    _utils_listeners__WEBPACK_IMPORTED_MODULE_1__/* .PubSub.getInstance */ .pS.getInstance().emit(_utils_listeners__WEBPACK_IMPORTED_MODULE_1__/* .EVENTS.ITEM_CUSTOMIZATION_REQUIRED */ .FP.ITEM_CUSTOMIZATION_REQUIRED, item, true);
};


/***/ }),

/***/ 13169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63228);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _urbanpiper_engineering_meraki_components_dist_Cells_Carousel__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59423);
/* harmony import */ var _urbanpiper_engineering_meraki_components_dist_Organisms_MenuPanel__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22358);
/* harmony import */ var _menu_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(92064);
/* harmony import */ var _menu_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_menu_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _utils_listeners__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(25268);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26793);
/* harmony import */ var _hooks_cart_util__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(12557);
/* harmony import */ var _hooks_is_mobile_hook__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(43346);
















const FloatingStack = next_dynamic__WEBPACK_IMPORTED_MODULE_7___default()(()=>Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 2889)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(2889)
            ]
    },
    ssr: false
});
const FloatingCart = next_dynamic__WEBPACK_IMPORTED_MODULE_7___default()(()=>__webpack_require__.e(/* import() */ 1169).then(__webpack_require__.bind(__webpack_require__, 71169)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(71169)
            ]
    },
    ssr: false
});
const FloatingStatus = next_dynamic__WEBPACK_IMPORTED_MODULE_7___default()(()=>__webpack_require__.e(/* import() */ 3314).then(__webpack_require__.bind(__webpack_require__, 53314)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(53314)
            ]
    },
    ssr: false
});
function MenuPage(param) {
    let { _webBanner , _mobileBanner , categoryId , seoConfig , businessInfo , likeButton , recommendedItems , showFoodType , showItemSort , showItemFilter  } = param;
    const isMobile = (0,_hooks_is_mobile_hook__WEBPACK_IMPORTED_MODULE_11__/* .useIsMobile */ .d)();
    const [webBanner, setWebBanner] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(_webBanner);
    const [mobileBanner, setMobileBanner] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(_mobileBanner);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)();
    const { t  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_12__/* .useTranslation */ .$)();
    const useCartState = _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getCartState */ .ZP.getCartState().hook();
    const useStoreState = _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getStoreState */ .ZP.getStoreState().hook();
    const useUserState = _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getUserState */ .ZP.getUserState().hook();
    const [cartItems, totalItems, subTotal] = useCartState((state)=>{
        var _state_cart, _state_cart1, _state_cart2;
        return [
            ((_state_cart = state.cart) === null || _state_cart === void 0 ? void 0 : _state_cart.items) || [],
            (_state_cart1 = state.cart) === null || _state_cart1 === void 0 ? void 0 : _state_cart1.item_count,
            (_state_cart2 = state.cart) === null || _state_cart2 === void 0 ? void 0 : _state_cart2.sub_total
        ];
    });
    const selectedStore = useStoreState((state)=>state.selectedStore);
    const [itemsMap, setItemsMap] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({});
    const [allCategories, setAllCategories] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    const language = useUserState((state)=>state.language);
    const isUserAuthenticated = _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_3__/* ["default"].isUserAuthenticated */ .ZP.isUserAuthenticated();
    const [sortFilter, setSortFilter] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({});
    const [activeOrder, setActiveOrder] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null);
    const [selectedfilterOptions, setSelectedfilterOptions] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    const [selectedSortOptions, setSelectedSortOptions] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null);
    const [filterSortIndicatorData, setFilterSortIndicatorData] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        showFilterIndicator: false,
        showSortIndicator: false
    });
    const [categoriesLoading, setCategoriesLoading] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true);
    const onFilterByChange = (checked, id)=>{
        if (checked && !selectedfilterOptions.includes(id)) {
            setSelectedfilterOptions([
                ...selectedfilterOptions,
                id
            ]);
        } else {
            if (selectedfilterOptions.includes(id)) {
                setSelectedfilterOptions(selectedfilterOptions.filter((filterId)=>filterId != id));
            }
        }
    };
    const onSortByChange = (id)=>{
        var _sortFilter_sort_by;
        setSelectedSortOptions((_sortFilter_sort_by = sortFilter.sort_by) === null || _sortFilter_sort_by === void 0 ? void 0 : _sortFilter_sort_by[id]);
    };
    const onFilterByCallback = (selectedSortOptions, selectedfilterOptions)=>{
        setSelectedSortOptions(selectedSortOptions);
        setSelectedfilterOptions(selectedfilterOptions);
        repopulateCategories(selectedSortOptions, selectedfilterOptions);
        try {
            if (selectedfilterOptions === null || selectedfilterOptions === void 0 ? void 0 : selectedfilterOptions.length) {
                const _selectedfilterOptions = [
                    ...selectedfilterOptions
                ].map(Number);
                let appliedFilters = [];
                let filters = (sortFilter === null || sortFilter === void 0 ? void 0 : sortFilter.filters) || [];
                filters.map((filter)=>{
                    var _filter_options;
                    filter === null || filter === void 0 ? void 0 : (_filter_options = filter.options) === null || _filter_options === void 0 ? void 0 : _filter_options.forEach((param)=>{
                        let { id , title  } = param;
                        if (_selectedfilterOptions.includes(id)) {
                            appliedFilters.push(title);
                        }
                    });
                });
                _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_3__/* ["default"].analyticsPublish */ .ZP.analyticsPublish(_urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_3__/* .ANALYTICS_EVENTS.FILTER_APPLIED */ .dW.FILTER_APPLIED, {
                    filter_by: appliedFilters.join(", ")
                });
            }
        } catch (error) {
            console.log("AnalyticsPublish: ", _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_3__/* .ANALYTICS_EVENTS.FILTER_APPLIED */ .dW.FILTER_APPLIED, error);
        }
        try {
            if (selectedSortOptions) {
                _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_3__/* ["default"].analyticsPublish */ .ZP.analyticsPublish(_urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_3__/* .ANALYTICS_EVENTS.SORT_APPLIED */ .dW.SORT_APPLIED, {
                    sort_by: selectedSortOptions
                });
            }
        } catch (error1) {
            console.log("AnalyticsPublish: ", _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_3__/* .ANALYTICS_EVENTS.SORT_APPLIED */ .dW.SORT_APPLIED, error1);
        }
    };
    const onFilterClearCallback = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(()=>{
        setSelectedfilterOptions([]);
        onFilterByCallback(selectedSortOptions, []);
        setFilterSortIndicatorData({
            showFilterIndicator: false,
            showSortIndicator: (selectedSortOptions === null || selectedSortOptions === void 0 ? void 0 : selectedSortOptions.length) > 0
        });
    }, [
        selectedSortOptions
    ]);
    const onSortClearCallback = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(()=>{
        setSelectedSortOptions(null);
        onFilterByCallback(null, selectedfilterOptions);
        setFilterSortIndicatorData({
            showFilterIndicator: (selectedfilterOptions === null || selectedfilterOptions === void 0 ? void 0 : selectedfilterOptions.length) > 0,
            showSortIndicator: false
        });
    }, [
        selectedfilterOptions
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getSortFilters */ .ZP.getSortFilters().then((_sortFilter)=>{
            const _updatedSortFilter = {};
            if (showItemSort) {
                _updatedSortFilter["sort_by"] = _sortFilter["sort_by"];
            }
            if (showItemFilter) {
                _updatedSortFilter["filters"] = _sortFilter["filters"];
            }
            setSortFilter(_updatedSortFilter);
        });
        if (isUserAuthenticated) {
            _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getActiveOrders */ .ZP.getActiveOrders().then((orders)=>{
                if (orders.length > 0) {
                    setActiveOrder(orders[0]);
                }
            }).catch(()=>{
            // do nothing
            });
        }
    }, [
        showItemSort,
        showItemFilter,
        isUserAuthenticated
    ]);
    const updateBanners = async ()=>{
        var _banners_images;
        const banners = await _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getBannerImages */ .ZP.getBannerImages({
            type: [
                "web_banner",
                "mobile_web_banner"
            ]
        });
        const { webBanner , mobileBanner  } = banners === null || banners === void 0 ? void 0 : (_banners_images = banners.images) === null || _banners_images === void 0 ? void 0 : _banners_images.reduce((acc, banner)=>{
            if (banner.img_type.match("web_banner") !== null) {
                acc.webBanner.push(banner);
            }
            if (banner.img_type.match("mobile_web_banner") !== null) {
                acc.mobileBanner.push(banner);
            }
            return acc;
        }, {
            webBanner: [],
            mobileBanner: []
        });
        return {
            webBanner,
            mobileBanner
        };
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.id) {
            updateBanners().then((param)=>{
                let { webBanner , mobileBanner  } = param;
                setWebBanner(webBanner);
                setMobileBanner(mobileBanner);
            }).catch(()=>{
                setWebBanner([]);
                setMobileBanner([]);
            });
        }
    }, [
        selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.id
    ]);
    const repopulateCategories = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)((selectedSortOptions, selectedfilterOptions)=>{
        setCategoriesLoading(true);
        _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getCategories */ .ZP.getCategories({
            recommendedItems,
            sort_by: selectedSortOptions,
            filter_by: selectedfilterOptions
        }).then((_categories)=>{
            setAllCategories(_categories);
            if (!_categories.length) {
                setItemsMap({});
            }
            setFilterSortIndicatorData({
                showFilterIndicator: (selectedfilterOptions === null || selectedfilterOptions === void 0 ? void 0 : selectedfilterOptions.length) > 0,
                showSortIndicator: (selectedSortOptions === null || selectedSortOptions === void 0 ? void 0 : selectedSortOptions.length) > 0
            });
        }).finally(()=>{
            setCategoriesLoading(false);
        });
    }, [
        recommendedItems,
        language
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        setSelectedSortOptions(null);
        setSelectedfilterOptions([]);
        repopulateCategories(null, []);
    }, [
        selectedStore,
        recommendedItems,
        language
    ]);
    const onCategoryChange = async (category)=>{
        const categorySlug = category === null || category === void 0 ? void 0 : category.slug;
        if (categorySlug) {
            router.push("/category/".concat(category.id, "/").concat(categorySlug), "", {
                scroll: false
            });
        }
        try {
            _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_3__/* ["default"].analyticsPublish */ .ZP.analyticsPublish(_urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_3__/* .ANALYTICS_EVENTS.CATEGORY_DETAIL */ .dW.CATEGORY_DETAIL, {
                ...category
            });
        } catch (error) {
            console.log("AnalyticsPublish: ", _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_3__/* .ANALYTICS_EVENTS.CATEGORY_DETAIL */ .dW.CATEGORY_DETAIL, error);
        }
    };
    const toggleFavourite = async (item, status)=>{
        if (status) {
            await _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_3__/* ["default"].addItemAsFavourite */ .ZP.addItemAsFavourite(item.id);
        } else {
            await _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_3__/* ["default"].removeItemAsFavourite */ .ZP.removeItemAsFavourite(item.id);
        }
    };
    const onError = (err, item)=>{
        if (err.message === _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_3__/* .Exceptions.LOGIN_REQUIRED */ .XM.LOGIN_REQUIRED) {
            _utils_listeners__WEBPACK_IMPORTED_MODULE_9__/* .PubSub.getInstance */ .pS.getInstance().emit(_utils_listeners__WEBPACK_IMPORTED_MODULE_9__/* .EVENTS.LOGIN_REQUIRED */ .FP.LOGIN_REQUIRED);
        }
        if (err.message === _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_3__/* .Exceptions.STORE_SELECTION_REQUIRED */ .XM.STORE_SELECTION_REQUIRED) {
            _utils_listeners__WEBPACK_IMPORTED_MODULE_9__/* .PubSub.getInstance */ .pS.getInstance().emit(_utils_listeners__WEBPACK_IMPORTED_MODULE_9__/* .EVENTS.STORE_SELECTION_REQUIRED */ .FP.STORE_SELECTION_REQUIRED);
        }
    };
    const fetchCategoryItems = async (categoryIds)=>{
    /**
     * TODO: We will need a config in root config which will decide whether to fetch all items
     * at once or once by once
     */ // if (!categoryIds?.length) return;
    // // get unfetched categories
    // const unfetchedCategories = categoryIds.filter(
    //   (id: number) => !itemsMap[id] && !isNaN(id)
    // );
    // if (!unfetchedCategories?.length) return;
    // setItemsMap((itemsMap: any) => ({
    //   ...itemsMap,
    //   ...unfetchedCategories.reduce(
    //     (result, category) => ({
    //       ...result,
    //       [category]: [],
    //     }),
    //     {}
    //   ),
    // }));
    // const categoryItems = await MerakiSDK.getCategoryItems({
    //   categoryIds: unfetchedCategories,
    //   sort_by: selectedSortOptions,
    //   filter_by: selectedfilterOptions,
    // });
    // const categoryItemMap = categoryItems?.reduce((acc: any, category: any) => {
    //   acc[category.id] = category.items;
    //   return acc;
    // }, {});
    // setItemsMap((itemsMap: any) => ({
    //   ...itemsMap,
    //   ...categoryItemMap,
    // }));
    };
    const getFullCatalogue = async ()=>{
        const itemsMapTemp = {};
        allCategories.forEach((category)=>{
            var _category_sub_categories;
            if (category === null || category === void 0 ? void 0 : (_category_sub_categories = category.sub_categories) === null || _category_sub_categories === void 0 ? void 0 : _category_sub_categories.length) {
                category.sub_categories.forEach((subCategory)=>{
                    itemsMapTemp[subCategory.id] = [];
                });
            } else {
                itemsMapTemp[category.id] = [];
            }
        });
        const categoryIds = Object.keys(itemsMapTemp).map((id)=>Number(id));
        const categoryItems = await _urbanpiper_engineering_meraki_sdk__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getCategoryItems */ .ZP.getCategoryItems({
            categoryIds: categoryIds,
            sort_by: selectedSortOptions,
            filter_by: selectedfilterOptions
        });
        const categoryItemMap = categoryItems === null || categoryItems === void 0 ? void 0 : categoryItems.reduce((acc, category)=>{
            acc[category.id] = category.items;
            return acc;
        }, {});
        setItemsMap(categoryItemMap);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        getFullCatalogue();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        allCategories
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_menu_module_scss__WEBPACK_IMPORTED_MODULE_13___default().page),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "".concat((_menu_module_scss__WEBPACK_IMPORTED_MODULE_13___default().menu), " container"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                            children: seoConfig.title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            name: "description",
                            content: seoConfig.description
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            name: "keywords",
                            content: seoConfig.keywords
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_urbanpiper_engineering_meraki_components_dist_Cells_Carousel__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    classes: (_menu_module_scss__WEBPACK_IMPORTED_MODULE_13___default().carousel),
                    mobileSlides: mobileBanner,
                    desktopSlides: webBanner,
                    imageComponent: (next_image__WEBPACK_IMPORTED_MODULE_4___default())
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_menu_module_scss__WEBPACK_IMPORTED_MODULE_13___default().itemList),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_urbanpiper_engineering_meraki_components_dist_Organisms_MenuPanel__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        loading: categoriesLoading,
                        isFavouriteEnabled: likeButton,
                        showFoodType: showFoodType,
                        minOrder: (businessInfo === null || businessInfo === void 0 ? void 0 : businessInfo.min_order_total) || 0,
                        selectedCategory: Number(categoryId),
                        sortFilter: sortFilter,
                        categories: allCategories,
                        itemsMap: itemsMap,
                        onCategoryClick: onCategoryChange,
                        imageComponent: (next_image__WEBPACK_IMPORTED_MODULE_4___default()),
                        fetchCategoryItems: fetchCategoryItems,
                        onItemUpdate: _hooks_cart_util__WEBPACK_IMPORTED_MODULE_10__/* .onItemUpdate */ .d4,
                        cartItems: cartItems,
                        totalItems: totalItems,
                        subTotal: subTotal,
                        onError: onError,
                        onItemClicked: (item)=>{
                            sessionStorage.setItem("scrolledSoFar", String(window.pageYOffset));
                            router.push("/item/".concat(item.id, "/").concat(item.slug));
                        },
                        onCheckoutClicked: async ()=>{
                            await router.push("/checkout");
                        },
                        toggleFavourite: toggleFavourite,
                        onFilterByCallback: onFilterByCallback,
                        onFilterByChange: onFilterByChange,
                        onSortByChange: onSortByChange,
                        onFilterClearCallback: onFilterClearCallback,
                        onSortClearCallback: onSortClearCallback,
                        selectedfilterOptions: selectedfilterOptions,
                        selectedSortOptions: selectedSortOptions,
                        editCustomizationCallback: _hooks_cart_util__WEBPACK_IMPORTED_MODULE_10__/* .onItemCustomization */ .Dd,
                        filterSortIndicatorData: filterSortIndicatorData,
                        itemLevelInstructionsEnabled: true
                    })
                }),
                isMobile && totalItems > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FloatingStack, {
                    order: 2,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FloatingCart, {
                        item_count: totalItems,
                        minOrder: (businessInfo === null || businessInfo === void 0 ? void 0 : businessInfo.min_order_total) || 0,
                        sub_total: subTotal,
                        onClick: ()=>router.push("/checkout")
                    })
                }),
                activeOrder && !totalItems ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FloatingStack, {
                    order: 1,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FloatingStatus, {
                        variant: "order",
                        onCtaClick: ()=>router.push("/orders/".concat(activeOrder.id))
                    })
                }) : null
            ]
        })
    });
}
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (MenuPage);


/***/ }),

/***/ 25268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FP": function() { return /* binding */ EVENTS; },
/* harmony export */   "pS": function() { return /* binding */ PubSub; }
/* harmony export */ });
/**
 * this file creates a pub/sub system for the app
 */ class PubSub {
    static getInstance() {
        if (!PubSub.instance) {
            PubSub.instance = new PubSub();
        }
        return PubSub.instance;
    }
    addListener(event, callback) {
        if (!this.events[event]) {
            this.events[event] = [];
        }
        this.events[event].push(callback);
        return {
            event,
            index: this.events[event].length - 1
        };
    }
    removeListener(listener) {
        var _this_events, _this_events_listener_event;
        if (!((_this_events = this.events) === null || _this_events === void 0 ? void 0 : (_this_events_listener_event = _this_events[listener.event]) === null || _this_events_listener_event === void 0 ? void 0 : _this_events_listener_event[listener.index])) {
            return;
        }
        this.events[listener.event] = this.events[listener.event].filter((cb, index)=>index !== listener.index);
    }
    emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        if (!this.events[event]) {
            return;
        }
        this.events[event].forEach((cb)=>cb(...args));
    }
    constructor(){
        this.events = {};
    }
}
/* harmony default export */ __webpack_exports__["ZP"] = (PubSub.getInstance());
var EVENTS;
(function(EVENTS) {
    EVENTS[EVENTS["LOGIN_REQUIRED"] = 0] = "LOGIN_REQUIRED";
    EVENTS[EVENTS["STORE_SELECTION_REQUIRED"] = 1] = "STORE_SELECTION_REQUIRED";
    EVENTS[EVENTS["ITEM_CUSTOMIZATION_REQUIRED"] = 2] = "ITEM_CUSTOMIZATION_REQUIRED";
    EVENTS[EVENTS["ITEM_REPEAT_OR_NOT_REQUIRED"] = 3] = "ITEM_REPEAT_OR_NOT_REQUIRED";
    EVENTS[EVENTS["ADD_TO_CART"] = 4] = "ADD_TO_CART";
})(EVENTS || (EVENTS = {}));


/***/ }),

/***/ 92064:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu_menu__mvOIQ","itemList":"menu_itemList__MEO1C","page":"menu_page__CWTSD"};

/***/ })

}]);